import img1 from "../assets/projects/pexels-dimkidama-15115560.jpg";
import img2 from "../assets/projects/pexels-firmbee-com-22729701-6963740.jpg";
import img3 from "../assets/projects/pexels-magnetme-3917414-5839461.jpg";
import img4 from "../assets/projects/pexels-rdne-7310202.jpg";

export const showcaseData = {
  images: [img1, img2, img3, img4, img2],
};
